services.factory('TestService', [
    function TestService() {

        function say() {
            return 'hello';
        };

        return {
            say: say
        }

    }]);